import React, { useEffect } from "react";
import CardV2 from "../../../shared-components/CardV2/CardV2";
import FeaturedArtist from "../../../shared-components/FeaturedArtist/FeaturedArtist";
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

// Import Swiper React components
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";


function HomeV5() {
  useEffect(() => {
    document.body.classList.add("light-ui");
    document.body.classList.add("light-ui--two");

    return () => {
      document.body.classList.remove("light-ui");
      document.body.classList.remove("light-ui--two");
      // Cleanup: Remove the script when the component unmounts
    };

  }, []); // Runs only once when the component mounts
  AnimationFileLoader();

  let featuredArtistHook = useSwiper();

  let notableDropHook = useSwiper();

  let browserCategoryHook=useSwiper();
  return (
    <>

      {/* Banner */}
      <div
        className="banner layer style--three overlay ov-hidden"
        data-bg-img="/img/bg/banner-bg4.png"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* Banner Content */}
              <div className="banner-content text-white mb-5 mb-lg-0">
                <h5>you won’t believe your eyes</h5>
                <h1>
                  Digital Collection & Sell on <span>NFTs</span>
                </h1>
                <p>
                  Anefty, we’re excited about brand new type of digital good
                  called NavLink non fungible tokens We’re proud to be the first and
                  largest marketplace for NFTs.
                </p>
                <ul className="list-info text-white">
                  <li>
                    <h4>
                      <span className="counter">3</span>k
                      <span className="c1">+</span>
                    </h4>
                    <h6>Artwork</h6>
                  </li>
                  <li>
                    <h4>
                      <span className="counter">9</span>k
                      <span className="c1">+</span>
                    </h4>
                    <h6>Auction</h6>
                  </li>
                  <li>
                    <h4>
                      <span className="counter">6</span>k
                      <span className="c1">+</span>
                    </h4>
                    <h6>Artist</h6>
                  </li>
                </ul>
                <div className="button-group flex-column flex-sm-row align-items-start align-items-sm-center">
                  <NavLink to="create.html" className="btn mb-3 mb-sm-0">
                    <img src="/img/icons/discover.svg" alt="" className="svg" />
                    Explore NFT
                  </NavLink>
                  <NavLink to="create.html" className="btn btn-border">
                    <img src="/img/icons/bid.svg" alt="" className="svg" />
                    Place NavLink bid
                  </NavLink>
                </div>
              </div>
              {/* End Banner Content */}
            </div>
            <div className="col-lg-6">
              {/* Banner IMG */}
              <div className="banner-img move-img">
                {/* Vdo btn */}
                <NavLink
                  to="https://www.youtube.com/watch?v=gfGuPd1CELo"
                  className="vdo_btn popup-video ms-xl-4"
                >
                  <img src="/img/icons/play2.svg" alt="" className="svg" />
                </NavLink>
                {/* End Vdo btn */}

                <img
                  src="/img/media/banner-big-img.png"
                  className="ms-xl-4"
                  alt=""
                />
                <div className="banner-small-img d-none d-md-block">
                  <img src="/img/media/banner-small-img.png" alt="" />
                </div>
              </div>
              {/* End Banner IMG */}
            </div>
          </div>
        </div>
      </div>
      {/* End Banner */}

      {/* Create & Sell NFTs  */}
      <section className="pt-120 pb-90 white-bg">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {/* Section Title */}
              <div className="section-title style--two">
                <h2>Create & Sell Your NFTs</h2>
              </div>
              {/* End Section Title */}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {/* Sell NFTs */}
              <ul className="selling-process-list style--two">
                <li>
                  <div className="icon">
                    <img src="/img/icons/sp1.svg" alt="" />
                  </div>
                  <div className="content">
                    <h5>Setup wallet</h5>
                  </div>
                </li>
                <li className="selling-sep">
                  <img src="/img/icons/sp-sep.svg" alt="" />
                </li>
                <li>
                  <div className="icon">
                    <img src="/img/icons/sp2.svg" alt="" />
                  </div>
                  <div className="content">
                    <h5>Add to NFT</h5>
                  </div>
                </li>
                <li className="selling-sep">
                  <img src="/img/icons/sp-sep.svg" alt="" />
                </li>
                <li>
                  <div className="icon">
                    <img src="/img/icons/sp3.svg" alt="" />
                  </div>
                  <div className="content">
                    <h5>Print voucher</h5>
                  </div>
                </li>
                <li className="selling-sep">
                  <img src="/img/icons/sp-sep.svg" alt="" />
                </li>
                <li>
                  <div className="icon">
                    <img src="/img/icons/sp4.svg" alt="" />
                  </div>
                  <div className="content">
                    <h5>Payment Bill</h5>
                  </div>
                </li>
                <li className="selling-sep">
                  <img src="/img/icons/sp-sep.svg" alt="" />
                </li>
                <li>
                  <div className="icon">
                    <img src="/img/icons/sp5.svg" alt="" />
                  </div>
                  <div className="content">
                    <h5>NFT Shipped</h5>
                  </div>
                </li>
              </ul>
              {/* End Sell NFTs */}
            </div>
          </div>
        </div>
      </section>
      {/* End Create & Sell NFTs  */}

      {/* Feeds */}
      <section className="pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-xl-4">
              {/* Section Title */}
              <div className="section-title style--two d-flex align-items-center justify-content-between">
                <h2>Feeds</h2>

                <select className="select-rounded light mt-1 me-xl-4">
                  <option value="Following">Following</option>
                  <option value="Meka_Verse">Meka_Verse</option>
                  <option value="Bored_YachtClub">Bored_YachtClub</option>
                  <option value="Bambooz_lers">Bambooz_lers</option>
                  <option value="The_Humanoids">The_Humanoids</option>
                  <option value="Stacked_Toadz">Stacked_Toadz</option>
                </select>
              </div>
              {/* End Section Title */}
            </div>
            <div className="col-xl-8 mb-30 mb-xl-0">
              <div className="d-flex align-items-center flex-wrap justify-content-center justify-content-lg-between justify-content-xl-end">
                <div
                  id="filters"
                  className="text-dark d-flex flex-wrap justify-content-center justify-content-xl-end"
                >
                  <button className="button is-checked" data-filter="*">
                    All
                  </button>
                  <button className="button" data-filter=":not(.artwork)">
                    Artwork
                  </button>
                  <button className="button" data-filter=":not(.photography)">
                    Photography
                  </button>
                  <button className="button" data-filter=":not(.games)">
                    Games
                  </button>
                  <button className="button" data-filter=":not(.domain)">
                    Domains
                  </button>
                  <button className="button" data-filter=":not(.memes)">
                    Memes
                  </button>
                </div>
                <NavLink
                  to="explore.html"
                  className="btn btn-sm ms-3 d-none d-lg-inline-flex"
                >
                  <img src="/img/icons/view-all.svg" alt="" className="svg" />
                  View All
                </NavLink>
              </div>
            </div>
          </div>
          <div className="grid row justify-content-center">
            <div className="col-xl-3 col-lg-4 col-md-6 element-item artwork memes">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product10.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Colourful Painting"
                price="0.99 ETH"
                info="3 to 100"
                likes="13.6k"
                classList="single-product style--four mb-30"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item photography">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product10.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Redical Painting"
                price="1.99 ETH"
                info="9 to 100"
                likes="13.6k"
                classList="single-product style--four mb-30"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item games">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product10.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Colourful Painting"
                price="2.09 ETH"
                info="2 to 220"
                likes="13.6k"
                classList="single-product style--four mb-30"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item domain">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product10.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Horrotic Painting"
                price="1.89 ETH"
                info="7 to 120"
                likes="13.6k"
                classList="single-product style--four mb-30"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item artwork">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product13.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Animal Girl Painting"
                price="4.36 ETH"
                info="5 to 200"
                likes="13.6k"
                classList="single-product style--four mb-30"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item photography">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product14.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="The Third Eye"
                price="3.66 ETH"
                info="3 to 320"
                likes="13.6k"
                classList="single-product style--four mb-30"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item games memes">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product14.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Glue Painting"
                price="0.99 ETH"
                info="30 to 100"
                likes="13.6k"
                classList="single-product style--four mb-30"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item domain">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product14.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Osean Painting"
                price="1.69 ETH"
                info="1 to 100"
                likes="13.6k"
                classList="single-product style--four mb-30"
              />

              {/* End Single Product */}
            </div>
          </div>
          <div className="row">
            <div className="col-12 d-lg-none text-center mb-30">
              <NavLink to="explore.html" className="btn btn-sm ms-3">
                <img src="/img/icons/view-all.svg" alt="" className="svg" />
                View All
              </NavLink>
            </div>
          </div>
        </div>
      </section>
      {/* End Feeds */}

      {/* Featured Artists Section  */}
      <section className="pt-120 pb-90 white-bg">
        <div className="container">
          <div className="row">
            <div className="col-sm-8">
              {/* Section Title */}
              <div className="section-title style--two">
                <h2>Featured Artists</h2>
              </div>
              {/* End Section Title */}
            </div>
            <div className="col-sm-4 d-none d-sm-block">
              <div className="swiper-nav">
                <div
                  className="swiper-button swiper-button-prev"
                  onClick={() => {
                    featuredArtistHook != null
                      ? featuredArtistHook.slidePrev()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M15 18 9 12 15 6" />
                  </svg>
                </div>
                <div
                  className="swiper-button swiper-button-next"
                  onClick={() => {
                    featuredArtistHook != null
                      ? featuredArtistHook.slideNext()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18 15 12 9 6" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              {/* Swiper */}

              <Swiper
                className="swiper"
                onSwiper={(swiper) => {
                  featuredArtistHook = swiper;
                }}
                autoplay={true}
                loop={true}
                navigation={true}
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={30}
                slidesPerView={4}
                onSlideChange={() => console.log("slide change")}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  420: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  992: { slidesPerView: 4 },
                  1200: { slidesPerView: 5 },
                  1400: { slidesPerView: 6 },
                }}
              >
                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Summy Scottt"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Kwami Luca"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>

                <SwiperSlide>

                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Tommy Teddy"
                    classList="featured-artists style--two"
                  />

                </SwiperSlide>

                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Kandi Logan"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Owen Parker"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Tyler Trevor"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>


                {/* In order to make the infine loop working we have to add double the amount of slides  get the slideperview from swiper hook => params => slidesPerView */}

                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Summy Scottt"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Kwami Luca"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>

                <SwiperSlide>

                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Tommy Teddy"
                    classList="featured-artists style--two"
                  />

                </SwiperSlide>

                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Kandi Logan"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Owen Parker"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <FeaturedArtist
                    coverImgSrc="/img/media/fa-cover1.png"
                    profileImgSrc="/img/media/fa-profile1.png"
                    authorName="Tyler Trevor"
                    classList="featured-artists style--two"
                  />
                </SwiperSlide>


                {/* End  */}
              </Swiper>


            </div>
          </div>
        </div>
      </section>
      {/* End Featured Artists Section  */}

      {/* Notable Drops */}
      <section className="pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-sm-8">
              {/* Section Title */}
              <div className="section-title style--two">
                <h2>Notable Drops</h2>
              </div>
              {/* End Section Title */}
            </div>
            <div className="col-sm-4 d-none d-sm-block">
              <div className="swiper-nav">
                <div
                  className="swiper-button swiper-button-prev"
                  onClick={() => {
                    notableDropHook != null
                      ? notableDropHook.slidePrev()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M15 18 9 12 15 6" />
                  </svg>
                </div>
                <div
                  className="swiper-button swiper-button-next"
                  onClick={() => {
                    notableDropHook != null
                      ? notableDropHook.slideNext()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18 15 12 9 6" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {/* Swiper */}

              <Swiper
                className="swiper shadow-support live-auction"
                onSwiper={(swiper) => {
                  notableDropHook = swiper;
                }}
                autoplay={true}
                loop={true}
                navigation={true}
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={30}
                slidesPerView={4}
                onSlideChange={() => console.log("slide change")}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                  1400: { slidesPerView: 4 },
                }}
              >

                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Colourful Painting"
                    price="0.99 ETH"
                    info="3 to 100"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--four"
                  />

                </SwiperSlide>


                <SwiperSlide>

                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Redical Painting"
                    price="1.98 ETH"
                    info="9 to 100"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--four"
                  />
                </SwiperSlide>


                <SwiperSlide>

                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Colourful Painting"
                    price="2.09 ETH"
                    info="2 to 220"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--four"
                  />
                </SwiperSlide>


                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Horrotic Painting"
                    price="1.89 ETH"
                    info="7 to 120"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--four"
                  />

                </SwiperSlide>

              </Swiper>

            </div>
          </div>
        </div>
      </section>
      {/* End Notable Drops */}

      {/* Browse Category */}
      <section className="pt-120 pb-120 white-bg">
        <div className="container">
          <div className="row">
            <div className="col-sm-8">
              {/* Section Title */}
              <div className="section-title style--two">
                <h2>Browse Category</h2>
              </div>
              {/* End Section Title */}
            </div>
            <div className="col-sm-4 d-none d-sm-block">
            <div className="swiper-nav">
                <div
                  className="swiper-button swiper-button-prev"
                  onClick={() => {
                    browserCategoryHook != null
                      ? browserCategoryHook.slidePrev()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M15 18 9 12 15 6" />
                  </svg>
                </div>
                <div
                  className="swiper-button swiper-button-next"
                  onClick={() => {
                    browserCategoryHook != null
                      ? browserCategoryHook.slideNext()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18 15 12 9 6" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {/* Swiper */}

              <Swiper
                className="swiper live-auction"
                onSwiper={(swiper) => {
                  browserCategoryHook = swiper;
                }}
                autoplay={true}
                loop={true}
                navigation={true}
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={30}
                slidesPerView={4}
                onSlideChange={() => console.log("slide change")}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                }}
              >

                <SwiperSlide>
                  <NavLink to="explore.html" className="category-item style--two">
                    <img src="/img/media/cat1.png" alt="" />

                    <div className="content">
                      <img src="/img/media/cat-s1.png" alt="" />
                      <h5>Art Painting</h5>
                    </div>
                  </NavLink>
                </SwiperSlide>

                <SwiperSlide>
                  <NavLink to="explore.html" className="category-item style--two">
                    <img src="/img/media/cat2.png" alt="" />

                    <div className="content">
                      <img src="/img/media/cat-s2.png" alt="" />
                      <h5>Trading Painting</h5>
                    </div>
                  </NavLink>
                </SwiperSlide>

                <SwiperSlide>
                  <NavLink to="explore.html" className="category-item style--two">
                    <img src="/img/media/cat3.png" alt="" />

                    <div className="content">
                      <img src="/img/media/cat-s3.png" alt="" />
                      <h5>Virtual Painting</h5>
                    </div>
                  </NavLink>
                </SwiperSlide>


                {/* In order to make the infine loop working we have to add double the amount of slides  get the slideperview from swiper hook => params => slidesPerView */}
                <SwiperSlide>
                  <NavLink to="explore.html" className="category-item style--two">
                    <img src="/img/media/cat1.png" alt="" />

                    <div className="content">
                      <img src="/img/media/cat-s1.png" alt="" />
                      <h5>Art Painting</h5>
                    </div>
                  </NavLink>
                </SwiperSlide>

                <SwiperSlide>
                  <NavLink to="explore.html" className="category-item style--two">
                    <img src="/img/media/cat2.png" alt="" />

                    <div className="content">
                      <img src="/img/media/cat-s2.png" alt="" />
                      <h5>Trading Painting</h5>
                    </div>
                  </NavLink>
                </SwiperSlide>

                <SwiperSlide>
                  <NavLink to="explore.html" className="category-item style--two">
                    <img src="/img/media/cat3.png" alt="" />

                    <div className="content">
                      <img src="/img/media/cat-s3.png" alt="" />
                      <h5>Virtual Painting</h5>
                    </div>
                  </NavLink>
                </SwiperSlide>
                {/* End */}

              </Swiper>

            </div>
          </div>
        </div>
      </section>
      {/* End Browse Category */}
    </>
  );
}

export default HomeV5;
